// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f22cb05","239":"5671e7c1","453":"06082e70","455":"cbafb3b7"}[chunkId] + ".chunk.js";
};